var React = require('react');

function AurumPixel (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"40.75 0 0 0 0 40.74 27.16 40.74 27.16 27.17 13.58 27.17 13.58 13.58 27.16 13.58 27.16 27.17 40.75 27.17 40.75 0","fill":"#231f20"}));
}

AurumPixel.defaultProps = {"aria-labelledby":"aurum-pixel","width":"50","viewBox":"0 0 40.75 40.74"};

module.exports = AurumPixel;

AurumPixel.default = AurumPixel;
